import { commonOrganisationDetails, stylingGetCompanyStyling } from '@/api'
import FabricatorLogo from '@/assets/images/logo.svg'
import { useAuthStore } from '@/pinia/auth'
import { useCustomerStore } from '@/pinia/customer'
import { config } from '@/utils/config'
import { defineStore } from 'pinia'

export const useStyleStore = defineStore('style', {
  persist: true,
  state: () => ({
    fabricator: null,
    pageName: null,
    companyStyles: null
  }),
  actions: {
    setPageName(name) {
      this.pageName = name
    },
    async refresh() {
      await this.loadFabricatorStyle()
      const authStore = useAuthStore()
      if (authStore.loggedIn && window.VITE_APP_INSTALLATION_TYPE !== 'business') {
        await this.loadCustomerStyle()
      }
    },
    async loadFabricatorStyle() {
      const details = await commonOrganisationDetails()
      this.fabricator = details
    },
    async loadCustomerStyle() {
      const customerStore = useCustomerStore()
      let customer = customerStore?.customer
      customerStore.setCustomer(customer)
    },
    async getCompanyStyles(companyId) {
      const customerStore = useCustomerStore()
      companyId = companyId || customerStore?.customer?.companyId
      if (companyId) {
        const styles = await stylingGetCompanyStyling(companyId)
        this.companyStyles = styles
      } else if (!this.companyStyles) {
        return this.fabricator?.styling
      }
      return this.companyStyles
    }
  },
  getters: {
    isCompanyStylingEnabled() {
      return true
    },
    back_to_site_link(state) {
      try {
        const url = state.fabricator.web

        return !url.includes('//') ? `//${url}` : url
      } catch {
        return false
      }
    },
    fabricator_logo(state) {
      try {
        return `${config.image_base_url}${state.fabricator.styling.logo}`
      } catch {
        return FabricatorLogo
      }
    },
    customer_logo(state) {
      try {
        return `${config.image_base_url}${state.companyStyles.logo}`
      } catch {
        return ''
      }
    },
    fabricator_name(state) {
      try {
        return `${state.fabricator.name}`
      } catch {
        return 'QUOTILA'
      }
    }
  }
})
